/** KDS Pagination — 32×32 px page controls. */
export const paginationItemSize = '32px';

export const paginationItemBorderRadius = 'md';

/** 4px — Figma `--2xs` between page controls. */
export const paginationItemGap = '1';

/** 8px — Figma `--sm` within page-size and jump-to groups. */
export const paginationSectionGap = '2';

/** 16px — Figma gap between jump-to block and page navigation. */
export const paginationBarActionsGap = '4';

/** Sibling pages shown on each side of the current page. */
export const paginationDefaultSiblingCount = 1;

/** Show every page number (no ellipsis) when total pages is at most this value. */
export const paginationMaxPagesWithoutEllipsis = 6;

export const paginationJumpToInputWidth = '64px';

export const paginationGoButtonWidth = '40px';

export const paginationPageSizeSelectWidth = '64px';

export const paginationDefaultPageSizeOptions = [
  { value: 25, label: '25' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
] as const;

/** Cursor (keyset) pager page-size options — keyset lists also offer a 10-row page. */
export const cursorPaginationDefaultPageSizeOptions = [
  { value: 10, label: '10' },
  { value: 25, label: '25' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
] as const;

export const paginationDefaultItemUnit = 'results';

export const paginationLabelColor = 'neutral.350';
